module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAsUlEQVR4AWOgC+hfpvX3qNz/Y4QRVINtn3HJPN1vh+VJ0ABESTP13x5UIFZD47bqNeeXxywIPnbv8H/cAKqhY1cTkDPlYF/rjnqHCWYLT8whoGH39e1ATu6q1EkHeiHO69/bSdiGJafmA22AaOj11DknqIaJEH5o2V678dLa+IVhfvWG29Q0gHIENICRqU1TtVXpIavSI7gQkoZuN+vqRRBRwhpsWlOsynYD+YQ1DEoAAIUvD8Nta0naAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KM.png
// module id = 1182
// module chunks = 0